const qs = require("qs");
const getURL = (protocol = "https") => {
	let url = window.location.href.split("/")[2];
	let splitUrl = url.split(".");
	if (splitUrl[1] === "portalsekolah") {
		return `${protocol}://backend-dirkampus.portalsekolah.co.id`;
	} else if (splitUrl[1] === "portalmurid") {
		return `${protocol}://backend-dirkampus.portalmurid.com`;
	} else {
		return `${protocol}://backend-dirkampus.portalsiswa.id`;
	}
};
const getPSURL = (protocol = "https") => {
	let url = window.location.href.split("/")[2];
	let splitUrl = url.split(".");
	if (splitUrl[1] === "portalsekolah") {
		return `${protocol}://backend.portalsekolah.co.id`;
	} else if (splitUrl[1] === "portalmurid") {
		return `${protocol}://backend.portalmurid.com`;
	} else {
		return `${protocol}://backend.portalsiswa.id`;
	}
};

export const baseURL = (() => {
	return getURL();
})();

export const socketBaseURL = (() => {
	return getURL("wss");
})();

export const homeUrl = (() => {
	let url = window.location.href.split("/")[2];
	let splitUrl = url.split(".");
	if (splitUrl[1] === "portalsekolah") {
		return `portalsekolah.co.id`;
	} else if (splitUrl[1] === "portalmurid") {
		return `portalmurid.com`;
	} else if (splitUrl[1] === "portalsiswa") {
		return `portalsiswa.id`;
	} else {
		return `localhost`;
	}
})();

export const mediaURL =
	homeUrl === "localhost" || homeUrl === "portalsiswa.id"
		? "https://dian-media-staging-jakarta.s3.ap-southeast-3.amazonaws.com/media"
		: homeUrl === "portalmurid.com"
		? "https://dian-media-uat-jakarta.s3.ap-southeast-3.amazonaws.com/media"
		: "https://dian-media-production.s3.ap-south-1.amazonaws.com/media";
export const mediaPreloadURL =
	homeUrl === "localhost" || homeUrl === "portalsiswa.id"
		? "https://dian-media-preloaded-jakarta.s3.ap-southeast-3.amazonaws.com"
		: homeUrl === "portalmurid.com"
		? "https://dian-media-preloaded-jakarta.s3.ap-southeast-3.amazonaws.com"
		: "https://dian-media-preloaded-jakarta.s3.ap-southeast-3.amazonaws.com";

const EPStore = {
	getNewAccessToken: { baseURL: getPSURL(), url: "api/v2/auth/refresh/", method: "POST" },
	getUserViaToken: { baseURL: getPSURL(), url: "api/auth/loggedinuserDetails/", method: "GET" },
	signUp: { baseURL: getPSURL(), url: "api/auth/userRegistration/", method: "POST" },
	logIn: { baseURL: getPSURL(), url: "api/auth/login/", method: "POST" },
	logout: { baseURL: getPSURL(), url: "api/auth/logout/", method: "POST" },
	sendResetLink: { baseURL: getPSURL(), url: "api/auth/send-reset-password-link/", method: "POST" },
	resetPassword: { baseURL: getPSURL(), url: "api/auth/reset-password/", method: "POST" },
	editUser: { baseURL: getPSURL(), url: "api/auth/profile/", method: "PATCH" },
	changePassword: { baseURL: getPSURL(), url: "api/auth/change-password/", method: "POST" },
	dashboard: { url: "api/college/dashboard/", method: "GET" },
	globalSearch: { url: "api/college/global_search", method: "GET" },
	favoriteList: { url: "api/user-tracking/favorite/list/", method: "GET" },
	favoriteCount: { url: "api/user-tracking/totalFavoritesForUser", method: "GET" },
	createFavorite: { url: "api/user-tracking/favorite/create/", method: "POST" },
	removeFavorite: { url: "api/user-tracking/favorite/detail/", method: "DELETE" },
	topCitiesView: { url: "api/college/topCitiesView", method: "GET" },
	locationList: { url: "api/college/collegeLocationNames/", method: "GET" },
	locationListWithCount: { url: "api/college/collegeLocationNamesWithCount/", method: "GET" },
	abroadAccreditationList: { url: "api/college/collegeAbroadAccreditationsList/", method: "GET" },
	majorNameList: { url: "api/major/majorNamesList/", method: "GET" },
	facultiesList: { url: "api/major/facultyList/", method: "GET" },
	sectorList: { url: "api/career/sectorNamesListingWithCount/", method: "GET" },
	collegeList: { url: "api/college/list/", method: "GET" },
	majorList: { url: "api/major/majorlist/", method: "GET" },
	careerList: { url: "api/career/list/", method: "GET" },
	scholarshipList: { url: "api/scholarship/list/", method: "GET" },
	collegeDetail: { url: "api/college/detail/", method: "GET" },
	majorDetail: { url: "api/major/majordetails/", method: "GET" },
	careerDetail: { url: "api/career/detail/", method: "GET" },
	scholarshipDetail: { url: "api/scholarship/detail/", method: "GET" },
};

export const generateRequestOptions = (key, options = {}) => {
	if (!key) {
		return null;
	}

	if (options && options.hasOwnProperty("queryParams")) {
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL")
				? `${EPStore[key].baseURL}/${EPStore[key].url}${options.urlParams || ""}?${qs.stringify(
						options.queryParams
				  )}`
				: `${baseURL}/${EPStore[key].url}${options.urlParams || ""}?${qs.stringify(
						options.queryParams,
						options.queryOptions
				  )}`,
		};
	}

	if (options && options.hasOwnProperty("urlParams")) {
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL")
				? `${EPStore[key].baseURL}/${EPStore[key].url}${options.urlParams}`
				: `${baseURL}/${EPStore[key].url}${options.urlParams}`,
		};
	}

	if (options && options.hasOwnProperty("innerUrlParams")) {
		let url = Object.keys(options.innerUrlParams).map((k) => {
			return EPStore[key].url.replace(`{${k}}`, options.innerUrlParams[k]);
		})[Object.keys(options.innerUrlParams).length - 1];
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL") ? `${EPStore[key].baseURL}/${url}` : `${baseURL}/${url}`,
		};
	}
	return {
		...EPStore[key],
		url: EPStore[key].hasOwnProperty("baseURL")
			? `${EPStore[key].baseURL}/${EPStore[key].url}`
			: `${baseURL}/${EPStore[key].url}`,
	};
};
export const generateURL = (key) => {
	return `${homeUrl}/${EPStore[key].url}`;
};
